import { createApp } from 'vue';

import root from './components/root.vue';

const app = createApp(root);

// router and store
import router from './routes/router';

app.use(router);

// pinia
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPersist);
app.use(pinia);

// bootstrap-vue
import BootstrapVue3 from 'bootstrap-vue-3';
app.use(BootstrapVue3);

// axios
import axios from 'axios';
axios.defaults.baseURL = '/api-frontend/';
app.config.globalProperties.axios = axios;

// Auth
import AuthManager from './auth/index';
import { useUserStore } from '@/stores/user';
app.use(AuthManager, { router: router, axios: axios, userStore: useUserStore() });

// forms
import FormGroup from './components/common/forms/form-group.vue';
app.component('form-group', FormGroup);

// mitt This need for the bus-events what was removed in Vue 3 ($on, $off ...)
import mitt from 'mitt';

app.config.globalProperties.emitter = mitt();

import validationSummary from './components/common/forms/validation-summary.vue';
app.component('validation-summary', validationSummary);

// progress bar
import VueProgressBar from '@aacassandra/vue3-progressbar';
app.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)'
});

//ReCaptcha v2
import VueRecaptcha from "vue3-recaptcha-v2";
app.use(VueRecaptcha, { siteKey: "6Lfq94MkAAAAAA4H5Rp5e1c87avyMqmiJQsMC8RL", alterDomain: false });

// toasts
import Toast from 'vue-toastification';

//Multi-language
import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';

const i18n = createI18n({
    locale: 'en',
    legacy: false,
    messages: {
        en: en,
        es: es,
        fr: fr
    }
});

const options = {
    timeout: 10000,
    pauseOnHover: true,
    closeOnClick: false,
    shareAppContext: true
};

app.use(Toast, options);

import './styles/main.scss';

app.use(i18n).mount('#app');